










export default
  name: 'InputMoney'

  props: ['value']

  computed:
    price:
      get: -> @value || 0
      set: (v) -> @$emit 'update:value', v

  methods:
    hiInput: (value) ->
      @$emit 'update:value', value
